<template>
    <div class="form-container">
        <DateField
            :customErrorMessage="$t('form.fields.dateOfBirth.errorMessage')"
            :formatLabel="$t('form.fields.dateOfBirth.format')"
            ageMin="18"
            name="dateOfBirth"
            ref="dateOfBirth"
        />
    </div>
</template>

<script>
export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'dateOfBirth',
            route: {
                relativeUrl: process.env.TERRITORY === 'pol' ? `data-urodzenia` : `date-of-birth`,
                name: 'apply.dateOfBirth',
                meta: {
                    title: 'form.sections.aboutYou.DateOfBirth.heading',
                    tooltip: process.env.IS_VERVENT ? 'form.sections.aboutYou.DateOfBirth.tooltip' : false,
                },
            },
            fields: {
                dateOfBirth: {
                    value: null,
                    formatterOnQuery: 'dateFormatter',
                    mappedKey: 'dob',
                    legacyMappedKey: 'date_of_birth',
                    mask: '##/##/####',
                    validationRules: {
                        required: true,
                        validDate: true,
                        dobBetween: {
                            min: 18,
                        },
                    },
                },
            },
        }
    },

    mounted() {
        this.autoFocus(this.$refs.dateOfBirth)
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
}
</script>
